import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AppliancesUsedTodayStyles";
import ApplianceDisc from "../components/ApplianceDisc";

export default class AppliancesUsedToday extends Component {
  render() {
    const { used_appliances } = this.props;

    return (
      <Fragment>
        {!used_appliances.length ? (
          <h3 className={css(styles.notUsed)}>
            No appliances used during this period
          </h3>
        ) : null}
        <div className={css(styles.usedTodayWrapper)}>
          {used_appliances &&
            Object.keys(used_appliances).map((appliance, i) => {
              return (
                <ApplianceDisc
                  title={used_appliances[appliance].name}
                  key={i}
                  size={"small"}
                  id={used_appliances[appliance].appliance_type_id}
                  icon={used_appliances[appliance].icon}
                  state={used_appliances[appliance].status.state}
                />
              );
            })}
        </div>
      </Fragment>
    );
  }
}
